<template>
  <div>
    <el-dialog title="完工确定" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
               style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose"
               v-el-drag-dialog v-el-dialog-center>
      <div id="containt">
        <div class="detail-wrap">
          <el-form ref="editForm" :model="formData">
            <div class="d-header" style="height: 450px!important;">

              <div class="d-cont edit-mce-box"
                   style=" overflow: unset!important;overflow-y: scroll!important;height: 100%!important; ">
                <div class="d-item">
                  <div class="title first"><b>审核内容</b></div>
                  <table class="table-detail" style="display: block;">
                    <tbody style="display: block;">
                    <tr style="display: block;">

                      <th>是否通过审核</th>
                      <td colspan="3">
                        <el-radio v-model="type" :label="'通过'">通过</el-radio>
                        <el-radio v-model="type" :label="'驳回'">驳回</el-radio>
                      </td>

                      <th>瑕疵等级</th>
                      <td>
                        <dict-select :dict-item-id.sync="reqData.defectLevel"
                                     :dict-item-name.sync="reqData.defectLevelName"
                                     dict-type="瑕疵等级"
                        />
                      </td>
                    </tr>
                    <tr style="display: block;">
                      <th>
                        <em class="f-red">*</em>
                        备注
                      </th>
                      <td colspan="7">
                        <!-- {{ formData.soOrderProcessDTO.finishNote }} -->
                        <el-input type="text" autocomplete="off" placeholder="请输入"
                                  v-model="formData.soOrderProcessDTO.comfirmNote" clearable />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div class="d-item">
                  <div class="title first"><b>{{$t('center.FeeSettlementSServiceProvider')}}</b>
                    <span class="expense">{{$t('center.CostThisOrder')}}:{{formData.soOrderSettleDTO.siteFinalAmount }}</span>
                  </div>

                  <table class="table-detail">
                    <tbody>
                    <div>
                      <tr>
                        <th>{{$t('center.StandardBase')}}</th>
                        <td>{{ formData.soOrderSettleDTO.standardBase }}</td>

                        <th>{{$t('center.ServiceCharge')}}</th>
                        <td>
                          <vxe-input type="number" v-model="formData.soOrderSettleDTO.siteAmount"/>
                          <!--                          {{ formData.soOrderSettleDTO.siteAmount }}-->
                          <!--                          <el-checkbox v-model="formData.soOrderSettleDTO.siteAmountPass"></el-checkbox>-->
                          <!--                          ({{$t('center.PassNot')}})-->
                        </td>
                      </tr>
                    </div>
                    <div>
                      <tr>
                        <th>
                          {{$t('center.RegionalCoefficient')}}
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.areaCoefficient }}
                        </td>

                        <th>
                          {{$t('center.DotStarFactor')}}
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.startCoefficient }}
                        </td>

                        <th>{{$t('center.SatisfactionCoefficient')}}</th>
                        <td>
                          {{ formData.soOrderSettleDTO.satisfactionCoefficient }}
                        </td>
                      </tr>
                    </div>
                    <div>
                      <tr>
                        <th>
                          {{$t('center.bonus')}}
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.bonusFee }}
                          <!--                          <el-checkbox v-model="formData.soOrderSettleDTO.bonusFeePass"></el-checkbox>-->
                          <!--                          <el-input v-model="formData.soOrderSettleDTO.bonusFee"/>-->
                        </td>

                        <th>
                          {{$t('center.RewardPunish')}}
                        </th>

                        <td>
                          {{ formData.soOrderSettleDTO.rewardAmount }}
                          <el-popover placement="top-start" width="205" trigger="hover">
                            <div>
                              <p>奖罚原因: {{formData.soOrderSettleDTO.rewardReason}}</p>
                            </div>
                            <span slot="reference" class="Instructions">{{$t('center.CheckTheCause')}}</span>
                          </el-popover>
                        </td>

                        <th>{{$t('center.DistanceCharge')}}</th>
                        <td colspan="3">
                          <!--                          {{ formData.soOrderSettleDTO.longDistanceAmount }}-->
                          <vxe-input v-model="formData.soOrderSettleDTO.longDistanceAmount" type="number" style="width: 100px"/>
                          ({{ formData.soOrderSettleDTO.mapLongDistance }}/{{ formData.soOrderSettleDTO.longDistance }})
                          <el-popover placement="top-start" width="205" trigger="hover">
                            <div>
                              <p>(地图远程数 / 远程公里数)</p>
                              <p>远程开始地址: {{formData.soOrderSettleDTO.mapBeginAddress}}</p>
                              <p>远程结束地址: {{formData.soOrderSettleDTO.mapEndAddress}}</p>
                            </div>
                            <span slot="reference" class="Instructions">{{$t('center.FieldDescription')}}</span>
                          </el-popover>
                        </td>
                      </tr>
                    </div>
                    <div>
                      <tr>
                        <th>
                          {{$t('center.ADHocExpense')}}
                        </th>
                        <td>
                          {{ formData.soOrderSettleDTO.specailAmount }}
                          <!--                          <span class="Instructions" @click="openRecordDialog(e)">{{$t('center.ViewCertificate')}}</span>-->
                          <!-- <i class="el-icon-tickets" style="margin-left:10px;color: #2a6494;"
                          @click="show3 = !show3">详细</i> -->
                        </td>
                      </tr>
                    </div>


                    <div v-for="item in dataList">
                      <tr>
                        <th v-if="item.length > 0">{{ item[0].key }}</th>
                        <td v-if="item.length > 0">{{ item[0].value }}</td>

                        <th v-if="item.length > 1">{{ item[1].key }}</th>
                        <td v-if="item.length > 1">{{ item[1].value }}</td>

                        <th v-if="item.length > 2">{{ item[2].key }}</th>
                        <td v-if="item.length > 2">{{ item[2].value }}</td>

                        <th v-if="item.length > 3">{{ item[3].key }}</th>
                        <td v-if="item.length > 3">{{ item[3].value }}</td>
                      </tr>
                    </div>

                    <!--                      <td>-->
                    <!--                        <el-input type="text" autocomplete="off" v-model="tenant.esiteOrderMan4" clearable/>-->
                    <!--                      </td>-->

                    </tbody>
                  </table>
                  <div>

                    <!--                    <vxe-table ref="filterTable" :data="formData.soOrderFeeAttribute"-->
                    <!--                      style="margin: 1px auto; width: 94%;" :stripe="true"-->
                    <!--                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"-->
                    <!--                      :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"-->
                    <!--                      show-overflow height="100" :column-config="{ resizable: true }">-->

                    <!--                      <vxe-column type="seq" width="55"> </vxe-column>-->
                    <!--                      <vxe-column field="feeAttributeId" title="费用类型" width="150" />-->
                    <!--                      <vxe-column field="feeAttributeName" title="费用名称" width="150" />-->
                    <!--                      <vxe-column field="amount" title="金额" width="100" />-->


                    <!--                    </vxe-table>-->
                    <vxe-table ref="filterTable" :data="soOrderSpecailFeeListToCompany"
                               style="margin: 1px auto; width: 94%;margin-top: 10px;" :stripe="true"
                               :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                               :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                               show-overflow height="100" :column-config="{ resizable: true }">
                      <vxe-column type="seq" width="55">
                      </vxe-column>

                      <!-- <vxe-column field="itemCode" title="产品编码"/> -->
                      <!--                      <vxe-column field="feeType" title="类型"/>-->

                      <vxe-column field="subjectName" :title="$t('center.ADHocExpenseName')" />
                      <vxe-column field="qty" :title="$t('center.quantity')" />
                      <vxe-column field="price" :title="$t('center.UnitPrice')" />
                      <vxe-column field="amount" :title="$t('center.amount')" />
                      <vxe-column field="unit" :title="$t('center.UnitOfAccount')" />


                    </vxe-table>

                  </div>
                </div>

                <div class="d-item">
                  <div class="title first"><b>服务内容</b></div>
                  <table class="table-detail" style="display: block;">
                    <tbody style="display: block;">
                    <tr style="display: block;">

                      <th>完工状态</th>
                      <td v-if="formData.soOrderProcessDTO.finishStatus == 1"><span
                        class="btn_t">正常完工</span></td>
                      <td v-else-if="formData.soOrderProcessDTO.finishStatus == 2"><span
                        class="btn_f">无法完工</span>
                      </td>
                      <td v-else-if="formData.soOrderProcessDTO.finishStatus == 3"><span
                        class="btn_f">需重新完工</span>
                      </td>
                      <td v-else>正常完工</td>

                      <th>保修类型</th>
                      <td colspan="3">
                        <el-radio v-model="formData.guaranteeType" :label="1"
                                  :disabled="isDisabledByGuaranteeTypeHeadBN">保内</el-radio>
                        <el-radio v-model="formData.guaranteeType" :label="2"
                                  :disabled="isDisabledByGuaranteeTypeHeadBW">保外</el-radio>
                        <el-radio v-model="formData.guaranteeType" :label="3"
                                  :disabled="isDisabledByGuaranteeTypeHeadBX">类型不详</el-radio>
                      </td>
                      <th>申请保外转保内</th>
                      <td>
                        <el-radio v-model="formData.outTransIn" :label="1"
                                  :disabled="disableByOutTransIn">是</el-radio>
                        <el-radio v-model="formData.outTransIn" :label="0"
                                  :disabled="disableByOutTransIn">否</el-radio>
                      </td>
                    </tr>
                    <!--											<tr v-if="fixStatusShow">-->
                    <!--												<th><em class="f-red">*</em>维修状态</th>-->
                    <!--												<td colspan="3">-->
                    <!--													<el-radio v-model="formData.soOrderProcessDTO.fixStatus"-->
                    <!--														:label="1">正常维修</el-radio>-->
                    <!--													<el-radio v-model="formData.soOrderProcessDTO.fixStatus"-->
                    <!--														:label="2">退机</el-radio>-->
                    <!--													<el-radio v-model="formData.soOrderProcessDTO.fixStatus"-->
                    <!--														:label="3">退换机</el-radio>-->
                    <!--												</td>-->
                    <!--											</tr>-->
                    <!--                    <tr v-if="insStatusShow || fixStatusShow">-->
                    <!--                      <th><em class="f-red">*</em>购买渠道</th>-->
                    <!--                      <td colspan="3">-->
                    <!--                        {{formData.buyChannelName}}-->
                    <!--&lt;!&ndash;                        <buy-channel-name-select&ndash;&gt;-->
                    <!--&lt;!&ndash;                          :buy-channel-name.sync="formData.buyChannelName" />&ndash;&gt;-->
                    <!--                      </td>-->
                    <!--                    </tr>-->
                    <tr style="display: block;">
                      <th>
                        <em class="f-red">*</em>
                        完工备注
                      </th>
                      <td colspan="7">
                        {{ formData.soOrderProcessDTO.finishNote }}
                        <!--                        <el-input type="text" autocomplete="off" placeholder="请输入"-->
                        <!--                                  v-model="formData.soOrderProcessDTO.finishNote" clearable />-->
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="formData.businessType == 2" class="d-item" style="position: relative;">
                  <div class="title first"><b>故障明细</b>
                    <div style="    position: absolute;right: 3%;top: 0;">
                      <el-button v-if="showFault" type="primary" class="button-sty btn_zdy"
                                 @click="showFaultDialog = true">
                        <i class="el-icon-plus"></i>
                        新增
                      </el-button>
                      <el-button v-if="showFault" type="primary" class="button-sty btn_zdy"
                                 @click="deleteFaultMed">
                        <i class="el-icon-delete"></i>
                        删除
                      </el-button>
                    </div>
                  </div>
                  <div class="product" style="">
                    <vxe-table ref="filterTable" :data="formData.soOrderFaultDTOList" class="table_item"
                               style="margin: 1px auto; width: 94%;" :stripe="true"
                               :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', fontWeight: '600', color: '#808080', width: '95%' }"
                               :row-config="{ height: 30, isHover: true, padding: 0, }"
                               :row-style="{ fontSize: '12px', }" show-overflow height="100"
                               :column-config="{ resizable: true }" @radio-change="currentChange">
                      <vxe-column type="radio" width="35" />
                      <vxe-column type="seq" width="55"></vxe-column>
                      <vxe-column field="symptomName" title="故障现象" width="200"></vxe-column>
                      <vxe-column field="reasonName" title="故障原因" width="250" />
                      <vxe-column field="methodName" title="服务措施" width="250" />
                      <vxe-column field="serverTypeName" title="服务类型" width="200" />
                    </vxe-table>
                  </div>
                </div>
                <div class="d-item">
                  <div class="title first"><b>完工资料</b></div>

                  <div v-for="item in formData.soOrderLineResultDTOList" :key="item.id">
                    <table class="table-detail">
                      <tbody>
                      <tbody>
                      <div>
                        <tr>
                          <div style="display: flex;">
                            <th>产品信息</th>
                            {{ item.bigCategoryName }}——{{
                              item.smallCategoryName }}——{{
                              item.itemName }}
                            <td>
                              <!--                              <span style="position: relative;bottom: 5px;"-->
                              <!--                                      class="Instructions"-->
                              <!--                                      @click="selectItem(item.orderLineId)"-->
                              <!--                            >更换产品</span>-->
                            </td>
                          </div>
                        </tr>
                        <tr>
                          <div>
                            <th><em class="f-red">*</em>购买日期</th>
                            <td>
                              {{item.buyDate}}
                              <!--                              <el-date-picker v-model="item.buyDate" format="yyyy-MM-dd"-->
                              <!--                                              value-format="yyyy-MM-dd HH:mm:ss" type="date"-->
                              <!--                                              placeholder="选择日期" @change="validateTime(item)">-->
                              <!--                              </el-date-picker>-->
                            </td>
                          </div>
                        </tr>
                        <tr>
                          <div>
                            <th><em class="f-red">*</em>机器条码1</th>
                            <td>
                              {{item.inCode}}
                              <!--                              <el-input type="text" autocomplete="off" placeholder="请输入"-->
                              <!--                                        v-model="item.inCode" clearable />-->
                            </td>
                            <!--                            <td>-->
                            <!--                              <span style="position: relative;bottom: 5px;"-->
                            <!--                                      class="Instructions"-->
                            <!--                                      @click="checkBarcode(item.inCode, item , item.index)">识别条码</span>-->
                            <!--                            </td>-->
                            <th>机器条码2</th>
                            <td>
                              {{item.outCode}}
                              <!--                              <el-input type="text" autocomplete="off" placeholder="请输入"-->
                              <!--                                        v-model="item.outCode" clearable />-->
                            </td>
                          </div>
                        </tr>
                        <tr>
                          <div>
                            <th>整机产品保修期</th>
                            <td>
                              {{ item.itemEndDate }}
                            </td>
                            <th>
                              关键零部件保修期
                            </th>
                            <td>
                              {{ item.partsEndDate }}
                            </td>
                            <th>产品安装出库时间</th>
                            <td>
                              {{ item.billDate }}
                            </td>
                          </div>
                        </tr>
                        <tr>
                          <div>
                            <th>
                              条码识别保修类型
                            </th>

                            <td colspan="3">
                              <el-radio v-model="item.guaranteeType"
                                        :disabled="isDisabledByGuaranteeType"
                                        :label="1">保内</el-radio>
                              <el-radio v-model="item.guaranteeType"
                                        :disabled="isDisabledByGuaranteeType"
                                        :label="2">保外</el-radio>
                              <el-radio v-model="item.guaranteeType"
                                        :disabled="isDisabledByGuaranteeType"
                                        :label="3">类型不详</el-radio>
                            </td>
                          </div>
                        </tr>
                      </div>
                      <tr style="display: block;">
                        <th><em class="f-red" v-if="item.finishMust1 == 1">*</em>照片1</th>
                        <td colspan="">
                          <div class="form_picture">
                            <div>
                              <!-- <el-upload style="display:flex;align-items: center;"
                              :action="api.uploadFileUrl" :on-remove="handleRemove1"
                              list-type="picture-card" :file-list="picList1"
                              :on-success="(res, file, fileList) => { handleSuccess1(res, file, fileList) }"
                              :on-change="(files, fileList) => { handleImageChange(fileList) }"
                              :auto-upload="true" :on-preview="handlePictureCardPreview"
                              :headers="headers">
                              <i slot="default" class="el-icon-plus"></i>
                            </el-upload> -->
                              <!--                              <photoUpload :photo-url.sync="item.finishPic1" />-->
                              <photo-show :photo-url.sync="item.finishPic1" style="width: 45px; height: 45px"/>
                            </div>
                          </div>
                          <!-- <baseUpload accept="image/png, image/jpeg" multi="true" :showSortInput="true"></baseUpload> -->
                        </td>
                        <th><em class="f-red" v-if="item.finishMust2 == 1">*</em>照片2</th>
                        <td>
                          <div>
                            <photo-show :photo-url.sync="item.finishPic2" style="width: 45px; height: 45px"/>
                            <!--                            <photoUpload :photo-url.sync="item.finishPic2" />-->
                          </div>
                        </td>

                        <th><em class="f-red" v-if="item.finishMust3 == 1">*</em>照片3</th>
                        <td>
                          <div>
                            <photo-show :photo-url.sync="item.finishPic3" style="width: 45px; height: 45px"/>
                            <!--                            <photoUpload :photo-url.sync="item.finishPic3" />-->

                          </div>
                        </td>
                      </tr>
                      <tr style="display: block; margin-top: 20px; ">
                        <th><em class="f-red" v-if="item.finishMust4 == 1">*</em>照片4</th>
                        <td>
                          <div>
                            <photo-show :photo-url.sync="item.finishPic4" style="width: 45px; height: 45px"/>
                            <!--                            <photoUpload :photo-url.sync="item.finishPic4" />-->

                          </div>
                        </td>
                        <th><em class="f-red" v-if="item.finishMust5 == 1">*</em>照片5</th>
                        <td>
                          <div>
                            <photo-show :photo-url.sync="item.finishPic5" style="width: 45px; height: 45px"/>
                            <!--                            <photoUpload :photo-url.sync="item.finishPic5" />-->

                          </div>
                        </td>
                        <th><em class="f-red" v-if="item.finishMust1 == 6">*</em>照片6</th>
                        <td>
                          <div>
                            <photo-show :photo-url.sync="item.finishPic6" style="width: 45px; height: 45px"/>
                            <!--                            <photoUpload :photo-url.sync="item.finishPic6" />-->

                          </div>
                        </td>
                        <th><em class="f-red" v-if="item.finishMust1 == 7">*</em>照片7</th>
                        <td>
                          <div>
                            <photo-show :photo-url.sync="item.finishPic7" style="width: 45px; height: 45px"/>
                            <!--                            <photoUpload :photo-url.sync="item.finishPic7" />-->

                          </div>
                        </td>
                      </tr>
                      <div>
                      </div>
                      </tbody>
                      </tbody>
                    </table>
                  </div>

                </div>

                <div v-if="formData.businessType == 2" class="d-item" style="position: relative;">
                  <div class="title first"><b>配件更换</b>
                    <!--                    <div style="    position: absolute;right: 3%;top: 0;">-->
                    <!--                      <el-button v-if="showParts" type="primary" class="button-sty btn_zdy"-->
                    <!--                                 @click="showSelectOrderPartsDialog = true">-->
                    <!--                        <i class="el-icon-plus"></i>-->
                    <!--                        新增-->
                    <!--                      </el-button>-->
                    <!--                      <el-button v-if="showParts" type="primary" class="button-sty btn_zdy"-->
                    <!--                                 @click="deletePartsMed">-->
                    <!--                        <i class="el-icon-delete"></i>-->
                    <!--                        删除-->
                    <!--                      </el-button>-->
                    <!--                    </div>-->
                  </div>
                  <el-collapse>
                    <el-collapse-item name="1">
                      <div>
                        <div>
                          <vxe-table ref="filterTable" :data="formData.soOrderPartsDTOList"
                                     class="table_item" style="margin: 1px auto; width: 94%;" :stripe="true"
                                     :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                     :row-config="{ height: 30, isHover: true, padding: 0, }"
                                     :row-style="{ fontSize: '12px', }" show-overflow height="100"
                                     :column-config="{ resizable: true }" @radio-change="currentChangeParts">
                            <vxe-column type="radio" width="35" />
                            <vxe-column type="selection" width="55">
                            </vxe-column>
                            <vxe-column field="partsCode" title="新件编码" />
                            <vxe-column field="partsName" title="新件名称" />
                            <vxe-column field="partsCode" title="旧件编码" />
                            <vxe-column field="partsName" title="旧件名称" />
                            <vxe-column field="sitePrice" title="价格" />
                            <vxe-column field="invQty" title="可用库存" />
                            <vxe-column field="qty" title="更换数量">
                              <template slot-scope="{ row,index }">
                                <el-input type="number" min="1" v-model="row.qty"
                                          style="width: 8vw;"
                                          @input="handleInput(row.invQty, row.qty, row.partsId)"></el-input>
                              </template>
                            </vxe-column>
                          </vxe-table>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
                <div class="d-item" style="position: relative;">
                  <div class="title first"><b>向用户收取费用</b>
                    <!--                    <div style="    position: absolute;right: 3%;top: 0;">-->
                    <!--                      <el-button type="primary" class="button-sty btn_zdy"-->
                    <!--                                 @click="showSelectOrderFeeDialog = true">-->
                    <!--                        <i class="el-icon-plus"></i>-->
                    <!--                        新增-->
                    <!--                      </el-button>-->
                    <!--                      <el-button type="primary" class="button-sty btn_zdy"-->
                    <!--                                 @click="deleteCompanyFeeMed">-->
                    <!--                        <i class="el-icon-delete"></i>-->
                    <!--                        删除-->
                    <!--                      </el-button>-->
                    <!--                    </div>-->
                  </div>
                  <el-collapse>
                    <el-collapse-item name="2">
                      <div>
                        <div>
                          <vxe-table ref="filterTable" :data="formData.soOrderUserFeeList"
                                     :key="feeTableKey" class="table_item" style="margin: 1px auto; width: 94%;"
                                     :stripe="true"
                                     :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                                     :row-config="{ height: 30, isHover: true, padding: 0, }"
                                     :row-style="{ fontSize: '12px', }" show-overflow height="100"
                                     :column-config="{ resizable: true }" @radio-change="currentChangeFees">
                            <vxe-column type="radio" width="35" />
                            <vxe-column type="selection" width="55">
                            </vxe-column>
                            <vxe-column field="name" title="费用名称">
                              <template slot-scope="{ row }">
                                <template v-if="row.initialValue !== '其他'">
                                  {{ row.name }}
                                </template>
                                <template v-else>
                                  <el-input v-model="row.name"></el-input>
                                </template>
                              </template>
                            </vxe-column>
                            <vxe-column field="price" title="单价">
                              <template slot-scope="{ row }">
                                <template v-if="row.initialValue !== '其他'">
                                  {{ row.price }}
                                </template>
                                <template v-else>
                                  <el-input type="number" v-model="row.price" :min="0" :disabled="false"
                                            @input="handleInputByFee(row.price, row.qty, row.feeId)"></el-input>
                                </template>
                              </template>
                            </vxe-column>
                            <vxe-column field="qty" title="更换数量">
                              <template slot-scope="{ row,index }">
                                <el-input type="number" min="1" v-model="row.qty"
                                          style="width: 8vw;"
                                          @input="handleInputByFee(row.price, row.qty, row.feeId)"></el-input>
                              </template>
                            </vxe-column>
                            <vxe-column field="amount" title="合计" />
                          </vxe-table>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>

              </div>
            </div>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
				<el-button type="primary" plain class="button-sty" @click="dialogClose">
					<i class="el-icon-close el-icon"></i>
					取 消
				</el-button>
				<el-button type="primary" @click="commitRow" class="button-sty">
					<i class="el-icon-check el-icon"></i>
					确 定
				</el-button>
			</span>
    </el-dialog>
    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList"
                     style="z-index: 3000!important;" />

    <!--		<preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"-->
    <!--			:visiable.sync="showPreconditionDialog" multi="true" />-->
    <preconditionDialog
      v-if="showPreconditionDialog"
      :visiable.sync="showPreconditionDialog"
      :param="{ orderLineId: tmpOrderLine }"
      @commitSelectedRow="commitSelectedRow"
    />
    <orderSelectPartsDialog v-if="showSelectOrderPartsDialog" :visiable.sync="showSelectOrderPartsDialog" :param="{
			itemId: formData.soOrderLineResultDTOList[0].itemId,
			orderId: formData.id
		}" @confirm="commitSelectedPartsRow" />
    <orderSelectFeeDialog v-if="showSelectOrderFeeDialog" :visiable.sync="showSelectOrderFeeDialog" :param="{
			itemId: formData.soOrderLineResultDTOList[0].itemId,
			orderId: formData.id,
			guaranteeType: formData.guaranteeType,
			serviceTypeId: formData.serverTypeId,
			brandId: formData.brandId,
			itemCategoryId: formData.soOrderLineResultDTOList[0].smallCategoryId != null && formData.soOrderLineResultDTOList[0].smallCategoryId != 0 ?
				formData.soOrderLineResultDTOList[0].smallCategoryId : formData.soOrderLineResultDTOList[0].bigCategoryId,
		}" @confirm="commitSelectedFeeRow" />
    <faultDialog v-if="showFaultDialog" @commitData="commitAreaData" :visiable.sync="showFaultDialog" multi="true"
                 :param="{
				bigCategoryId: formData.soOrderLineResultDTOList[0].bigCategoryId,
				smallCategoryId: formData.soOrderLineResultDTOList[0].smallCategoryId
			}" />
  </div>
</template>
<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'
import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import store from "@/store";

import api from "@/api/projectApi";
import { mapGetters } from "vuex";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";

import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import orderSelectPartsDialog from '@/views/dialogCommon/orderSelectPartsDialog.vue';
import orderSelectFeeDialog from "@/views/dialogCommon/orderSelectFeeDialog.vue";
import faultDialog from "@/views/dialogCommon/faultDialog.vue";
import BuyChannelSelect from "@/components/formItem/buyChannelSelect.vue";
import BuyChannelNameSelect from "@/components/formItem/buyChannelNameSelect.vue";
// 图片
import photoUpload from "@/components/formItem/photoUpload.vue"
import DictSelect from "@/components/formItem/dictSelect.vue";
import PhotoShow from "@/components/formItem/photoShow.vue";
export default {
  name: 'siteDialog',
  props: ['visiable', 'multi', 'param', 'orderId', 'assginType'],
  mixins: [selectDialogMixins],
  components: {
    PhotoShow,
    DictSelect,
    BuyChannelNameSelect,
    BuyChannelSelect,
    photoUpload,
    pager, preconditionDialog, orderSelectPartsDialog, orderSelectFeeDialog, faultDialog,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  created() {
    this.dataId = this.orderId
    console.log(this.dataId, "this.dataId的值");
    this.formData.id = this.orderId ? this.orderId : "";
    this.formData.orderId = this.formData.id
    this.callBackAssignType = this.assginType ? this.assginType : 0
  },
  data() {
    return {
      type: '通过',
      reqData: {
        defectLevel: null,
        defectLevelName: null,
        guaranteeType: null,
        longDistanceAmount: 0,
        siteAmount: 0,
        soOrderFaultDTOList: [],
      },



      tmpOrderLine:null,
      feeTableKey: 1,
      isDisabledByGuaranteeType: true,
      isDisabledByGuaranteeTypeHeadBN: false,
      isDisabledByGuaranteeTypeHeadBW: false,
      isDisabledByGuaranteeTypeHeadBX: false,
      disableByOutTransIn: true,

      deleteFaultList: [],
      deletePartsList: [],
      deleteFeesList: [],

      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      picList6: [],
      picList7: [],
      file: [],
      dialogImageUrl: '',
      dialogImageUrlList: [],
      dialogVisible: false,
      uploadDisabled: false,
      showFault: false,
      showParts: false,
      showSelectOrderPartsDialog: false,
      showSelectOrderFeeDialog: false,
      showPreconditionDialog: false,
      showFaultDialog: false,
      fixStatusShow: false,
      insStatusShow: false,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      callBackAssignType: 0,
      isCheckBarcode:false,
      // 查询参数
      formData: {
        finishMode: 'PC',
        id: '',
        orderId: '',
        orderNo: '', // 工单号,前缀"SO"+年月日+6位流水号
        createType: 0, // 生成方式：0默认;1客服;2excel;3接口;4公众号;5PC自建单;6APP自建单;7服务中心;9其它;94苏宁帮客;95京东服务市场;97天猫服务市场;98京东测量服务;99京东ue平台;100京东3C
        orderTypeId: 0, // 工单来源ID,关联bas_order_type.id
        serverTypeId: 0, // 服务类型ID,关联bas_service_type.id
        userType: 0, // 用户类型:0普通用户、1售前机、2工程机、3VIP用户、4经销商
        userName: '', // 用户姓名
        userMobile: '', // 来电号码
        userPhone1: '', // 其他号码1
        userPhone2: '', // 其他号码2
        userProvice: '', // 省
        userCity: '', // 市
        userCounty: '', // 县
        userTown: '', // 镇街
        areaId: 0, // 地区ID,关联bas_area.id
        userAddress: '', // 详细地址
        longitude: 0, // 经度
        latitude: 0, // 纬度
        guaranteeType: 1, // 保修类型：1保内、2保外、3未知
        brandId: 0, // 品牌ID,关联sn_company_brand.id
        buyDate: '', // 购买时间
        buyShop: '', // 购买商场
        invoiceNo: '', // 发票号
        brarcode: '', // 报单条码
        outOrderNo: '', // 外部订单号
        complaintTypeId: 0, // 客诉类型ID,关联bas_customer_complaint_type.id
        issueFaultId: 0, // 客服录单故障现象id,关联bas_fault_symptom.id
        appeals: '', // 述求
        stat: 0, // 状态：1登记;2发布;5已派网点;9已派师傅;13已出发;17已上门;20完工暂存;21已完工;22网点确认完工;23中心确认完工;24总部确认完工;91待结算;92结算驳回;93结算中止;94已结算;98挂起;99取消
        dispatchStat: '', // 工单标签
        partsStat: 0, // 配件状态：0无配件;1申请；2审核；3出库；4网点收货；8驳回；9取消；11更换；12网点返厂；13返厂确认
        recallStat: 0, // 回访状态：0未回访、1已抽样、2已回访;5用户已评价
        siteComplainStat: 0, // 申诉状态：0无申诉；3待申诉；5已申诉；7中心已审核；8中心驳回；9总部已处理；99取消
        qualityStat: 0, // 质检状态：0未质检；1质检通过；2质检不通过；
        orgId: 0, // 业务机构，关联脚手架机构表sys_dept.dept_id
        orgName: '', // 机构名称,冗余字段
        orgIdPath: '', // 机构ID路径,冗余字段.重要
        siteId: 0, // 网点ID,关联sn_user.id;
        siteName: '', // 网点名称,冗余字段
        bigSiteId: null,
        bigSiteName: '',
        engineerId: 0, // 工程师Id,关联sn_site_engineer.id
        engineerName: '', // 工程师名称,冗余字段
        takeTime: null, // 派单时间
        takeEngineerTime: null, // 派工程师时间
        openId: '', // 消费者报修时关联的微信号id
        sysmtomId: 0, // 故障现象id,关联bas_fault_symptom.id
        reasonId: 0, // 故障原因id,关联bas_fault_reason.id
        methodId: 0, // 维修措施id,关联bas_fix_method.id
        isMustRecall: 0, // 是否必访:0否1是
        isCallRecall: 0, // 是否可抽样:0否1是
        isUrgent: 0, // 是否急单:0否1是
        isReplaceFinish: 0, // 是否重新完工：0否1是
        urgeTimes: 0, // 催单次数
        complainTimes: 0, // 投诉次数
        managerId: 0, // 督办人,关联sys_user.id
        outTransIn: 0, // 申请保外转保内:0否1是
        settleId: 0, // 结算单ID,关联sf_batch_settle.id字段
        sendPay: '', // sendPay:打标标识，未定义
        serverTypeName: null,
        orderTypeName: null,
        symptomName: null,
        reasonName: null,
        methodName: null,

        billDate: null,
        itemEndDate: null,
        partsEndDate: null,
        soOrderLineResultDTOList: [],
        buyChannelName: null, // 购买渠道名称
        buyChannelId: null,

        urger: null,

        soOrderExtendDTO: {
          wishBookDate: '', // 期望上门/安装时间
          deliverTime: '', // 到货签收时间
          finishMode: 0, // 完工模式：1结算密码；2上传图片；3图片+条码；9无验证完工
          finishType: 0, // 完工方式:1总部代完工;2网点PC端完工;3网点APP完工;4师傅APP完工;5接口完工;9其他
          commentLevel: 0, // 短信满意度：1非常满意;2满意;3一般;4不满意;5非常不满意
          isSendCommentMessage: 0, // 是否已发送评价短信：0否1是
          qualityMan: '', // 质检人
          qualityDate: '', // 质检时间
          qualityRemark: '', // 质检备注
          secondSiteComplain: 0, // 是否二次申诉：0否1是
          isInstallSynchro: 0, // 是否送装同步：0否1是
          hangupType: 0, // 挂起类型：0总部挂起；1网点挂起
          hangupReason: '', // 挂起原因
          sendFlag: 0, // 外部系统传单标识:0未传;1失败;2已传
          sendMessage: '', // 外部系统传单返回信息
          sendDate: '', // 外部系统传单时间
          thirdSendFlag: 0, // 传第三方网点接口状态:0未传;1失败;2已传
          thirdSendDate: '', // 传第三方网点接口时间
          thirdSendMessage: '', // 传第三方网点接口备注,如失败时用来保存失败的原因
          tmfworderid: '', // 天猫服务市场的工单ID
          tbcustomerid: '', // 天猫服务市场的用户ID
          commercePraise: 0, // 是否电商好评：0否1是

          complaintObjectName: '', // 投诉对象
          complaintProperty: null, // 投诉性质ID,关联脚手架数据字典项目表sys_dict_item.id
          dealSatisfaction: 0,
          dutyJudge: null, // 责任判定ID,关联脚手架数据字典项目表sys_dict_item.id
          dutyJudgeSub: null, // 责任细分ID,关联脚手架数据字典项目表sys_dict_item.id
          handleModel: null, // 处理方式ID,关联脚手架数据字典项目表sys_dict_item.id
          handlePlan: '', // 处理方案
          consultType: null, // 咨询类型ID,关联脚手架数据字典项目表sys_dict_item.id
          consultTypeSub: null, //  咨询细分ID,关联脚手架数据字典项目表sys_dict_item.id
          praiseObjectName: '', //  表扬对象
          praiseType: null, //  表扬类型ID,关联脚手架数据字典项目表sys_dict_item.id
          praiseJudge: 0, //   表扬是否成立:0否1是
          rewardJudge: 0, //  奖励是否成立:0否1是

          complaintPropertyName: null,
          isIntransfer: null,
          dealSatisfactionName: null,
          dutyJudgeName: null,
          dutyJudgeSubName: null,
          handleModelName: null,
          consultTypeName: null,
          consultTypeSubName: null,
          praiseTypeName: null,

        },
        soOrderProcessDTO: {
          orderId: 0, // 工单id，关联so_order.id
          recallTime: '', // 回访时间
          complaintProcessTimes: 0, // 客诉跟进次数
          complaintProcesser: '', // 客诉跟进人
          complaintProcessDate: '', // 客诉跟进时间
          siteComplaintProcessDate: '', // 网点客诉跟进时间
          applyPayDate: '', // 进入结算池时间
          payDate: '', // 提交结算时间
          cancleDate: '', // 取消/退单时间
          returnId: 0, // 取消/退单原因：关联bas_return_type.id.
          returnName: null, // 取消/退单原因：关联bas_return_type.id.
          finishNote: '', // 完工备注
          comfirmNote: '', // 完工审核备注
          fixStatus: 1
        },

        soOrderSettleDTO: {
          siteFinalAmount: null,
          siteAmount: null,
          rewardAmount: null,
          mapLongDistance: null,
          longDistance: null,
          longDistanceAmount: null,
          userPayType: null,
          userPayName: null,
          userPayAccount: null,
          userPayStat: null,
          userPayNo: null,
          userPayTime: null,
          userPayStatMsg: null,
          productDate: null,
          installDate: null
        },
        soOrderSpecailFeeDTO: {
          amount: null
        },
        soOrderResultDTO: {
          inCode: null,
          outCode: null,
          finishPic1: null,
          finishPic2: null,
          finishPic3: null,
          finishPic4: null,
          finishPic5: null,
          finishPic6: null,
        },
        soOrderComplainDTOList: [],
        soOrderLineDTOList: [{}],
        soOrderPartsDTOList: [],
        soOrderPreconditionResultDTOList: [],
        soOrderOperationDTOList: [],
        soOrderSlaList: [],
        sfCheckBillDTOList: [],
        soOrderFaultDTOList: [],
        soOrderFeeAttributeList: [],
        soOrderCompanyFeeList: [],
        soOrderUserFeeList: [],
      },
      dataList: [],
      srcList: [],
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      selectedRow: {},
    };
  },
  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    },
  },
  watch: {
    'formData.outTransIn': {
      handler(newVal, oldVal) {
        if (newVal == 1) {
          this.isDisabledByGuaranteeTypeHeadBN = false
          this.isDisabledByGuaranteeTypeHeadBW = false
        } else if (this.formData.guaranteeType == 2) {
          this.isDisabledByGuaranteeTypeHeadBN = true
          this.isDisabledByGuaranteeTypeHeadBW = true
        }
        // else{
        //   this.formData.guaranteeType = 2
        //   this.isDisabledByGuaranteeTypeHeadBN = true
        //   this.isDisabledByGuaranteeTypeHeadBW = true
        // }
      },
      deep: true, // 加这个属性，深度监听
    },

  },
  mounted() {

    this.getData();
    this.formData.orderId = this.formData.id;
  },
  methods: {
    closeImgViewer() {
      this.dialogVisible = false
    },


    commitSelectedPartsRow(data) {
      console.log("这里选中的数据为" + data)
      data.forEach((map) => {
        map.partsId = map.id
        // map.qty = 1; // 向每个Map插入qty=1的键值对
        map.id = null
      });
      if (this.formData.soOrderPartsDTOList != null && this.formData.soOrderPartsDTOList.length > 0) {
        this.formData.soOrderPartsDTOList.forEach((mapParts) => {
          data.forEach((map) => {
            if (map.partsId == mapParts.partsId) {
              map.partsId = null
            }
          });
        });
        data.forEach((map) => {
          if (map.partsId != null) {
            this.formData.soOrderPartsDTOList.push(map)
            this.formData.soOrderPartsDTOList = this.formData.soOrderPartsDTOList.map((item) => {
              return { ...item, qty: 1 };
            });
          }
        });
      } else {
        this.formData.soOrderPartsDTOList = data
        this.formData.soOrderPartsDTOList = this.formData.soOrderPartsDTOList.map((item) => {
          return { ...item, qty: 1 };
        });
      }
    },
    commitSelectedFeeRow(data) {
      var feeType = null;
      data.forEach((map) => {
        feeType = map.feeType
        map.feeId = map.id
        map.id = null
        map.initialValue = map.name
      });
      if (this.formData.soOrderUserFeeList != null && this.formData.soOrderUserFeeList.length > 0) {
        this.formData.soOrderUserFeeList.forEach((mapParts) => {
          data.forEach((map) => {
            if (map.feeId == mapParts.feeId) {
              map.feeId = null
            }
          });
        });
        data.forEach((map) => {
          if (map.feeId != null) {
            this.formData.soOrderUserFeeList.push(map)
            this.formData.soOrderUserFeeList = this.formData.soOrderUserFeeList.map((item) => {
              return { ...item, qty: 1 };
            });
          }
        });
      } else {
        this.formData.soOrderUserFeeList = data
        this.formData.soOrderUserFeeList = this.formData.soOrderUserFeeList.map((item) => {
          return { ...item, qty: 1 };
        });
      }
    },
    // 第一个  表格
    formatter(row, column) {
      return row.isNeedReturn == 1 ? '是' : '否'
    },
    formatter1(row, column) {
      return row.isCheck == 1 ? '是' : '否'
    },
    formatter2(row, column) {
      return row.isPast == 1 ? '是' : '否'
    },
    formatter4(row, column) {
      return row.offAccounting == 1 ? "是" : "否"
    },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },
    cellClickEvent(e) {

    },

    handleInput(a, e, index) {
      if (a >= e) {
        this.formData.soOrderPartsDTOList.forEach((item) => {
          if (parseInt(item.partsId) === parseInt(index)) {
            item.qty = parseInt(e);
          }
        });
      } else {
        this.$message.error('更换数不能超过可用库存数')
        this.formData.soOrderPartsDTOList.forEach((item) => {
          if (parseInt(item.partsId) === parseInt(index)) {
            item.qty = parseInt(a);
          }
        });
      }
    },

    handleInputByFee(price, qty, index) {
      const amount = price * qty;
      this.formData.soOrderUserFeeList.forEach((item) => {
        if (parseInt(item.feeId) === parseInt(index)) {
          item.amount = parseInt(amount);
        }
      });
    },


    radioChangeEvent({ row }) {
      this.selectedRow = { id: row.id, name: row.userName, callBackAssignType: this.callBackAssignType }
    },
    commitAreaData(data) {
      if (this.formData.soOrderFaultDTOList != null && this.formData.soOrderFaultDTOList.length > 0) {
        let filter = this.formData.soOrderFaultDTOList.filter(item => item.methodId != data.methodId)
        filter.push(data)
        this.formData.soOrderFaultDTOList = filter
      } else {
        this.formData.soOrderFaultDTOList.push(data)
      }
    },

    commitRow() {
      // var resultFlag = false;
      // this.formData.soOrderLineResultDTOList.forEach(item => {
      //   if (item.inCode != null && item.inCode != '' && !this.isCheckBarcode) {
      //     this.$message.error('请先识别条码')
      //     resultFlag = true;
      //   }
      //
      //   if (item.buyDate == null || item.buyDate == '') {
      //     this.$message.error('购买时间必填')
      //     resultFlag = true;
      //   }
      // });
      //
      // if (resultFlag) {
      //   return false;
      // }
      //
      // if (this.formData.soOrderProcessDTO.fixStatus == null) {
      //   this.$message.error('维修状态必填')
      //   return false;
      // }
      // if (this.formData.soOrderProcessDTO.finishNote == null) {
      //   this.$message.error('完工备注必填')
      //   return false;
      // }
      // if (this.formData.soOrderLineResultDTOList.length == 0) {
      //   this.$message.error('工单异常，未找到产品明细')
      //   return false;
      // }
      // this.$mask.open()
      //
      // this.formData.soOrderSpecailFeeDTOList = this.formData.soOrderUserFeeList;
      // this.$http({
      //   url: api.soOrder.orderFinish,
      //   method: 'post',
      //   data: this.formData,
      //   isLoading: true,
      // }).then(res => {
      //
      //
      //   this.$message.success('操作成功')
      //   this.$emit('closeCompletionDialog', 1)
      //   // this.reload()// 需要刷新页面
      // })
      //

      if (!this.formData.soOrderProcessDTO.comfirmNote) {
        this.$message.error('备注不能为空')
        this.$mask.close()
        return
      }

      let url
      if (this.type === '通过') {
        url = api.soOrder.doOrderFinishUrl
      } else {
        url = api.soOrder.doOrderRejectUrl
      }
      this.$mask.open()

      this.reqData.orderId = this.formData.id
      this.reqData.guaranteeType = this.formData.guaranteeType
      this.reqData.soOrderFaultDTOList = this.formData.soOrderFaultDTOList
      this.reqData.siteAmount = this.formData.soOrderSettleDTO.siteAmount
      this.reqData.longDistanceAmount = this.formData.soOrderSettleDTO.longDistanceAmount
      this.reqData.comfirmNote = this.formData.soOrderProcessDTO.comfirmNote
      this.reqData.remark = this.formData.soOrderProcessDTO.comfirmNote
      this.reqData.outTransIn = this.formData.outTransIn

      console.log(this.reqData, '纽恩泰审核数据')
      this.$http.post(url, this.reqData).then(res => {
        this.$message.success('操作成功')
        this.$emit('closeDialog', 1)
        this.$mask.close()
      }).catch(res => {
        this.$message.error(res.data.data)
        this.$emit('closeDialog',0)
        this.$mask.close()
      })
    },

    selectItem(item){
      this.tmpOrderLine = item
      this.showPreconditionDialog = true
    },

    commitSelectedRow(data,orderLineId) {
      console.log('orderLineId=='+orderLineId)
      this.formData.soOrderLineResultDTOList.forEach(item => {
        if (item.orderLineId === orderLineId) {
          item.itemId = data.id
          item.itemName = data.itemName
          console.log(data.itemName)
          console.log(item.itemName)
          item.itemCode = data.itemCode
          item.bigCategoryId = data.bigCategoryId
          item.bigCategoryName = data.bigCategoryName
          item.smallCategoryId = data.smallCategoryId
          item.smallCategoryName = data.smallCategoryName
        }
      });
      // this.showPreconditionDialog = false
    },


    currentChange({ row }) {
      console.log("这里选中的故障明细为" + row)
      if (row) {
        this.deleteFaultList.push(row);
      } else {
        this.deleteFault = null;
      }
    },

    deleteFaultMed() {
      this.$baseConfirm('您确定要删除已选故障吗？').then(() => {
        let temp = this.formData.soOrderFaultDTOList;
        this.deleteFaultList.forEach(item => {
          temp = temp.filter(item1 => item1.methodId != item.methodId)
        })
        this.formData.soOrderFaultDTOList = temp
        this.deleteFaultList = [];
      })
    },

    currentChangeParts({ row }) {
      console.log("这里选中的配件明细为" + row)
      if (row) {
        this.deletePartsList.push(row);
      } else {
        this.deletePartsList = null;
      }
    },

    deletePartsMed() {
      this.$baseConfirm('您确定要删除已选配件吗？').then(() => {
        let temp = this.formData.soOrderPartsDTOList;
        this.deletePartsList.forEach(item => {
          temp = temp.filter(item1 => item1.partsCode != item.partsCode)
        })
        this.formData.soOrderPartsDTOList = temp
        this.deletePartsList = [];
      })
    },

    currentChangeFees({ row }) {
      if (row) {
        this.deleteFeesList.push(row);
      } else {
        this.deleteFeesList = null;
      }
    },

    deleteCompanyFeeMed() {
      this.$baseConfirm('您确定要删除已选费用吗？').then(() => {
        let temp = this.formData.soOrderUserFeeList;
        this.deleteFeesList.forEach(item => {
          temp = temp.filter(item1 => item1.feeId != item.feeId)
        })
        this.formData.soOrderUserFeeList = temp
        this.deleteFeesList = [];
        this.feeTableKey++;
      })
    },


    checkBarcode(inCode, item,index) {
      const barcode = inCode;
      const date = item.buyDate;
      // if(date==null||date==""){
      //   this.$message.error('请先选择购买日期');
      //   return
      // }
      if (barcode == null || barcode == "") {
        this.$message.error('请先填写条码');
        return
      }
      this.isCheckBarcode = true;
      this.$http({
        url: api.soOrder.checkBarcodeUrl,
        method: 'post',
        data: {
          barcode: barcode,
          orderId: this.formData.id,
          buyDate: date,
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (item.itemId != response.data.data.itemId) {
          this.$message.warning('条码与工单原产品不同，请重新选择故障明细与更换配件');
          this.formData.soOrderFaultDTOList = [];
          this.formData.soOrderPartsDTOList = [];
        }
        item.itemCode = response.data.data.itemCode
        item.itemName = response.data.data.itemName
        item.itemId = response.data.data.itemId
        item.bigCategoryId = response.data.data.bigCategoryId
        item.bigCategoryName = response.data.data.bigCategoryName
        item.smallCategoryId = response.data.data.smallCategoryId
        item.smallCategoryName = response.data.data.smallCategoryName
        item.buyDate = response.data.data.buyDate

        // this.formData.soOrderLineDTOList[index].itemId = response.data.data.itemId
        // this.formData.soOrderLineDTOList[index].itemName = response.data.data.itemName
        // this.formData.soOrderLineDTOList[index].itemCode = response.data.data.itemCode
        // this.formData.soOrderLineDTOList[index].bigCategoryId = response.data.data.bigCategoryId
        // this.formData.soOrderLineDTOList[index].bigCategoryName = response.data.data.bigCategoryName
        // this.formData.soOrderLineDTOList[index].smallCategoryId = response.data.data.smallCategoryId
        // this.formData.soOrderLineDTOList[index].smallCategoryName = response.data.data.smallCategoryName
        // if (response.data.data.buyDate != null && response.data.data.buyDate != '') {
        //   this.formData.soOrderLineDTOList[index].buyDate = response.data.data.buyDate
        // }

        // this.formData.soOrderLineResultDTOList[index].itemId = response.data.data.itemId
        // this.formData.soOrderLineResultDTOList[index].itemName = response.data.data.itemName
        // this.formData.soOrderLineResultDTOList[index].itemCode = response.data.data.itemCode
        // this.formData.soOrderLineResultDTOList[index].bigCategoryId = response.data.data.bigCategoryId
        // this.formData.soOrderLineResultDTOList[index].bigCategoryName = response.data.data.bigCategoryName
        // this.formData.soOrderLineResultDTOList[index].smallCategoryId = response.data.data.smallCategoryId
        // this.formData.soOrderLineResultDTOList[index].smallCategoryName = response.data.data.smallCategoryName
        // if (response.data.data.buyDate != null && response.data.data.buyDate != '') {
        //   this.formData.soOrderLineResultDTOList[index].buyDate = response.data.data.buyDate
        // }
        // this.formData.soOrderLineResultDTOList[index].guaranteeType = response.data.data.guaranteeType


        item.partsEndDate = response.data.data.partsEndDate
        item.itemEndDate = response.data.data.itemEndDate
        item.billDate = response.data.data.billDate
        if (this.formData.serviceType == 1) {
          item.guaranteeType = 1
        } else {
          item.guaranteeType = response.data.data.guaranteeType
        }
        if (item.guaranteeType == 2) {
          this.isDisabledByGuaranteeTypeHeadBN = true
          this.isDisabledByGuaranteeTypeHeadBW = true
          this.isDisabledByGuaranteeTypeHeadBX = true
          this.disableByOutTransIn = false
          this.formData.guaranteeType = 2
        }
        this.$message({
          type: response.data.type,
          message: response.data.content
        });
        // this.reload()// 需要刷新页面
      })
    },
    // 添加明细
    confirmSelectParts(data) {
      console.log(data, '明细')
      let temp = this.formData.spPartsApplyLineDTOList
      if (temp == null)
        temp = []
      data.forEach(item => {
        temp.push({
          partsId: item.partsId,
          partsCode: item.partsCode,
          partsName: item.partsName,
          sitePrice: item.sitePrice,
          applyQty: Number(item.waitQty) - Number(item.applyQty),
          applyAmount: item.sitePrice,
          checkQty: 0,
          checkAmount: 0,
          outQty: 0,
          outAmount: 0,
          getQty: 0,
          getAmount: 0,
          diffQty: 0,
          diffAmount: 0,
          getStat: 0,
          selectId: item.id,
          orderNo: item.orderNo ? item.orderNo : null,
          orderId: item.orderId ? item.orderId : null,
        })
      })
      this.formData.spPartsApplyLineDTOList = temp
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.$mask.open()
        this.isEdit = true;
        this.$http({
          url: api.soOrder.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          if (this.formData.outTransIn == null || this.formData.outTransIn == '') {
            this.formData.outTransIn = 0
          }
          if (this.formData.businessType == 2 || this.formData.businessType == 12) {
            this.showFault = true
            this.showParts = true
            this.fixStatusShow = true
            if (this.formData.guaranteeType == 1) {
              this.isDisabledByGuaranteeTypeHeadBW = false
              this.isDisabledByGuaranteeTypeHeadBN = false
              this.isDisabledByGuaranteeTypeHeadBX = true
            } else if (this.formData.guaranteeType == 3) {
              this.isDisabledByGuaranteeTypeHeadBN = false
              this.isDisabledByGuaranteeTypeHeadBW = false
              this.isDisabledByGuaranteeTypeHeadBX = false
            } else if (this.formData.guaranteeType == 2) {
              this.isDisabledByGuaranteeTypeHeadBN = true
              this.isDisabledByGuaranteeTypeHeadBW = true
              this.isDisabledByGuaranteeTypeHeadBX = true
              this.disableByOutTransIn = false
            }
          } else if (this.formData.businessType == 1) {
            this.insStatusShow = true;
            // this.formData.guaranteeType = 1
            this.isDisabledByGuaranteeTypeHeadBN = true
            this.isDisabledByGuaranteeTypeHeadBW = true
            this.isDisabledByGuaranteeTypeHeadBX = true
            if (this.formData.guaranteeType == 1) {
              this.isDisabledByGuaranteeTypeHeadBN = false
              this.isDisabledByGuaranteeTypeHeadBW = false
              this.isDisabledByGuaranteeTypeHeadBX = true
            } else if (this.formData.guaranteeType == 3) {
              this.isDisabledByGuaranteeTypeHeadBN = false
              this.isDisabledByGuaranteeTypeHeadBW = false
              this.isDisabledByGuaranteeTypeHeadBX = false
            } else if (this.formData.guaranteeType == 2) {
              this.isDisabledByGuaranteeTypeHeadBN = true
              this.isDisabledByGuaranteeTypeHeadBW = true
              this.isDisabledByGuaranteeTypeHeadBX = true
              this.disableByOutTransIn = false
            }
          } else {
            if (this.formData.guaranteeType == 1) {
              this.isDisabledByGuaranteeTypeHeadBW = false
              this.isDisabledByGuaranteeTypeHeadBN = false
              this.isDisabledByGuaranteeTypeHeadBX = true
            } else if (this.formData.guaranteeType == 3) {
              this.isDisabledByGuaranteeTypeHeadBN = false
              this.isDisabledByGuaranteeTypeHeadBW = false
              this.isDisabledByGuaranteeTypeHeadBX = false
            } else if (this.formData.guaranteeType == 2) {
              this.isDisabledByGuaranteeTypeHeadBN = true
              this.isDisabledByGuaranteeTypeHeadBW = true
              this.isDisabledByGuaranteeTypeHeadBX = true
              this.disableByOutTransIn = false
            }
          }

          if (this.formData.soOrderComplainDTOList != null && this.formData.soOrderComplainDTOList.length != 0) {
            this.formData.soOrderComplainDTOList.forEach(item => {
              let list = []
              if (item.fileUrl1 != null) {
                list.push(item.fileUrl1)
              }
              if (item.fileUrl2 != null) {
                list.push(item.fileUrl)
              }
              if (item.fileUrl3 != null) {
                list.push(item.fileUrl3)
              }
              item.srcList = list
            })
          }
          if (this.formData.soOrderPartsDTOList != null) {
            this.formData.soOrderPartsDTOList.forEach(item => {
              if (item.partsCode === this.formData.soOrderProcessDTO.changeBookReason) {
                this.formData.soOrderProcessDTO.changeBookReasonName = item.label
              }
            })
          }
          if (this.formData.soOrderProcessDTO != null) {
            if (this.formData.soOrderProcessDTO.fixStatus == null) {
              this.formData.soOrderProcessDTO.fixStatus = 1
            }
          } else {
            if (this.formData.soOrderProcessDTO.fixStatus == null) {
              this.formData.soOrderProcessDTO.fixStatus = 1
            }
          }

          if (!!this.formData.soOrderPartsDTOList) {
            if (!!this.formData.soOrderProcessDTO.changeBookReason) {
              this.changeBookReasonList.forEach(item => {
                if (item.id === this.formData.soOrderProcessDTO.changeBookReason) {
                  this.formData.soOrderProcessDTO.changeBookReasonName = item.label
                }
              })
            }
          }


          if (!!this.formData.soOrderExtendDTO) {
            if (!!this.formData.soOrderExtendDTO.complaintProperty) {
              this.complaintPropertyList.forEach(item => {
                if (item.id === this.formData.soOrderExtendDTO.complaintProperty) {
                  this.formData.soOrderExtendDTO.complaintPropertyName = item.label
                }
              })
            }
            if (!!this.formData.soOrderExtendDTO.handleModel) {
              this.handleModelList.forEach(item => {
                if (item.id === this.formData.soOrderExtendDTO.handleModel) {
                  this.formData.soOrderExtendDTO.handleModelName = item.label
                }
              })
            }
            if (!!this.formData.soOrderExtendDTO.consultType) {
              this.consultTypeList.forEach(item => {
                if (item.id === this.formData.soOrderExtendDTO.consultType) {
                  this.formData.soOrderExtendDTO.consultTypeName = item.label
                }
              })
            }
            if (!!this.formData.soOrderExtendDTO.consultTypeSub) {
              this.consultTypeSubList.forEach(item => {
                if (item.id === this.formData.soOrderExtendDTO.consultTypeSub) {
                  this.formData.soOrderExtendDTO.consultTypeSubName = item.label
                }
              })
            }
            if (!!this.formData.soOrderExtendDTO.praiseType) {
              this.praiseTypeList.forEach(item => {
                if (item.id === this.formData.soOrderExtendDTO.praiseType) {
                  this.formData.soOrderExtendDTO.praiseTypeName = item.label
                }
              })
            }
          }
          //对特设费用进行处理,分成向厂商申请和向用户收取
          if (this.formData.soOrderSpecailFeeDTOList) {
            this.formData.soOrderUserFeeList = [];
            this.formData.soOrderSpecailFeeDTOList.forEach((item) => {
              // 检查 feeType 是否为 1
              if (item.feeType === 1) {
                // 将满足条件的对象推入 soOrderCompanyFeeList 数组
                this.formData.soOrderCompanyFeeList.push(item);
              } else if (item.feeType === 2) {
                this.formData.soOrderUserFeeList.push(
                  {
                    id: item.id,
                    feeId: item.subjectId,
                    name: item.subjectName,
                    feeType: item.feeType,
                    qty: item.qty,
                    price: item.price,
                    amount: item.amount,
                    unit: item.unit
                  }
                )
              }
            });
          }
          if (this.formData.soOrderFeeAttributeList) {
            this.dataList = []
            let flag = 0
            let temp = []
            this.formData.soOrderFeeAttributeList.forEach(item => {
              if (flag < 4) {
                flag += 1
              } else {
                this.dataList.push(temp)
                flag = 0
                temp = []
              }
              temp.push({ key: item.feeAttributeName, value: item.amount })
            })
            if (temp.length > 0) {
              this.dataList.push(temp)
            }
          }
          if (this.dealType == 'orderEdit' && this.formData.areaId != null && this.formData.areaId != '') {
            this.$http({
              url: api.basArea.echoAddressUrl,
              method: 'post',
              data: { id: this.formData.areaId }
            }).then(res => {
              this.areaOption = res.data.data.options
              this.areaValues = res.data.data.values
            })
          }
          // const barcode = this.formData.soOrderResultDTO.inCode;
          // if (barcode != null && barcode != '') {
          // 	this.checkBarcode()
          // }
          this.$mask.close()
        })
      } else {
        this.enabled = true;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
::v-deep #containt .table-detail tbody tr td {
  padding: 0px 12px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

::v-deep .vxe-grid .vxe-form--item .vxe-form--item-title {
  width: 7vw !important;
}


.btn_zdy {
  // margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.Instructions {
  display: inline-block;
  text-decoration: underline;
  color: #00c4b3;
  margin-left: 5px;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 80px;
  height: 80px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 80px;
  height: 80px;
  padding: 0;
  position: inherit;
  cursor: pointer;
}

/* 推荐，实现简单 */
.el-upload-list__item.is-ready,
.el-upload-list__item.is-uploading {
  display: none !important;
}
::v-deep .el-collapse-item__wrap {
  border-bottom:none !important;
}
::v-deep .el-collapse-item__arrow{
  position: absolute;
  right: 0;
  top: 5px;
}
::v-deep .el-collapse {
  border: none!important;
}
::v-deep .el-collapse-item__header {
  height: 1px ;
  border: none!important;
}
</style>
